
/*
* 畫面定義檔，未來視情況拆成DB
* ==============================
* GetTabKeyList() 決定此特作問卷有幾個 Tab
* GetChapterListByTabKey() 每個 Tab 可能有多個章節同時顯示在這個 Tab
*/

//#region  介面定義

import { SpwkUtil } from "../../dao/SpwkUtil";
import { SpwkUtilV3 } from "../../dao/SpwkUtilV3";

/** 定義檔: 依照傳入的功能列表，決定畫面應該顯示那些題目 */
export function GetTabKeyList(uni_func_guids: string[]) {
  let tab_key_list = [];

  tab_key_list.push(SpwkUtil.CHAPTER_基本資料);
  tab_key_list.push(SpwkUtil.CHAPTER_作業經歷);
  
  tab_key_list.push(SpwkUtil.CHAPTER_既往病史);

  if (uni_func_guids.includes(SpwkUtilV3.B02_func_guid)) {
    tab_key_list.push(SpwkUtil.CHAPTER_既往病史_噪音作業);
  }

  tab_key_list.push(SpwkUtil.CHAPTER_生活習慣);

  tab_key_list.push(SpwkUtil.CHAPTER_自覺症狀);

  if (uni_func_guids.includes(SpwkUtilV3.B02_func_guid)) {
    tab_key_list.push(SpwkUtil.CHAPTER_自覺症狀_噪音作業);
  }

  if (uni_func_guids.includes(SpwkUtilV3.A98_func_guid)) {
    tab_key_list.push(SpwkUtil.CHAPTER_疲勞狀況);
  }

  tab_key_list.push(SpwkUtil.CHAPTER_環境監測);

  return tab_key_list;
}

/** 定義檔: 一個頁面可能對應多個章節 */
export function GetChapterListByTabKey(CurrTabKey: string): string[] {
  if (CurrTabKey === SpwkUtil.CHAPTER_基本資料) {
    // 基本資料 這個 Tab 包含檢查時期
    return [SpwkUtil.CHAPTER_基本資料, SpwkUtil.CHAPTER_檢查時期];
  } else {
    return [CurrTabKey]
  }
}

//#endregion